import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";

// Agent rows and cards are clickable as a whole but may hold their own buttons (bookmark).
// A <button> cannot live inside an <a>, so the title link stretches over the card instead
// (the card root must be `relative`; inner buttons sit above it with `relative z-10`).
export interface NvCardLinkProps {
  to?: string;
  // Router state, e.g. { source: "finder" } for the detail view log
  state?: unknown;
  className?: string;
  children: React.ReactNode;
}

function NvCardLink({ to, state, className, children }: NvCardLinkProps) {
  if (!to) return <span className={className}>{children}</span>;

  return (
    <Link to={to} state={state} className={cn("after:absolute after:inset-0 after:content-['']", className)}>
      {children}
    </Link>
  );
}

export { NvCardLink };
